/**
 *interface ILocation {
*    hash: string;
*    host: string;
*    hostname: string;
*    href: string;
*    origin: string;
*    pathname: string;
*    port: number;
*    protocol: string;
*    search: string;
*}
 * interface IExtendedLocation{
 *  uid: string
 *  title: string
 * }
 */

import { generateGUID } from "../utils";

const locationKeys = [
  'hash', 'host', 'hostname', 'href', 'origin', 'pathname', 'port', 'protocol', 'search'
];

/**
 *
 * @param {string | ILocation} location
 * @returns {ILocation}
 */
export function createSimpleLocation(location) {
  const anchor = (typeof location === 'string')
    ? getAnchorFromHref(location) : location;

  let locationObject = {};

  locationKeys.forEach(key => {
    locationObject[key] = anchor[key] || '';
  });

  // IE can have not origin
  if (!locationObject.origin) {
    locationObject = polyfillOrigin(locationObject);
  }

  return locationObject;
}

/**
 *
 * @param {ILocation} location
 * @param {string} title
 * @returns {IExtendedLocation}
 */
export function createExtendedLocation(location, title) {
  // constructor(location: ILocation | any, title?: string) {
  location = createSimpleLocation(location);

  location.uid = generateGUID();
  location.title = title;

  return location;
}

/**
 *
 * @param {string} href
 * @returns {Element} HTMLAnchorElement
 */
function getAnchorFromHref(href) {
  const anchor = document.createElement('a');
  anchor.setAttribute('href', href);
  return anchor;
}

function polyfillOrigin(locationObject) {
  // Port should be added ony if is different from default port for protocol
  // @see description of origin property here: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
  let port = '';
  if ((locationObject.protocol === 'https:' && +locationObject.port !== 443) || (locationObject.protocol === 'http:' && +locationObject.port !== 80)) {
    port = locationObject.port.toString();
  }

  locationObject.origin = locationObject.protocol + '//' + locationObject.hostname + (port.length > 0 ? ':' + port : '');
  return locationObject;
}
